<template>
  <div class="app-wrapper">
    <el-menu
      v-if="false"
      :default-active="activeIndex"
      class="top-menu"
      mode="horizontal"
      @select="handleSelect"
      :background-color="variables.menuBg"
      :text-color="variables.menuText"
      :active-text-color="variables.menuActiveText"
    >
      <template v-if="screenWidth > 1200">
        <el-menu-item
          v-for="(item, index) in menuData"
          :key="index"
          :index="item.menuId"
        >
          <i :class="item.menuPic+' menuIcon'"></i>
          <span class="menuName">{{ item.menuName }}</span>
        </el-menu-item>
      </template>
      <template v-if="screenWidth <= 1200">
        <el-menu-item
          v-for="(item, index) in menuData.slice(0, 5)"
          :key="index"
          :index="item.menuId"
        >
          <i :class="item.menuPic+' menuIcon'"></i>
          <span class="menuName">{{ item.menuName }}</span>
        </el-menu-item>
        <el-submenu index="submenu">
          <template slot="title"
            ><i class="el-icon-postcard"></i>更多菜单</template
          >
          <el-menu-item
            v-for="(item, index) in menuData.slice(5)"
            :key="index"
            :index="item.menuId"
          >
            <i :class="item.menuPic+' menuIcon'"></i>
            <span class="menuName">{{ item.menuName }}</span>
          </el-menu-item>
        </el-submenu>
      </template>
      <el-dropdown :hide-on-click="false" class="user-drop">
        <span class="el-dropdown-link">
          <span
            class="mr10"
            style="position: relative; top: -8px; color: #c7c7c7"
            >{{ userInfo.realname || "" }}</span
          >
          <img class="user-avatar" src="./../assets/用户.png" />
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <span @click="dialogPass=true" style="padding:0 20px;">修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item>
            <div @click="logout" style="padding: 0 20px">退出</div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-menu>

    <!-- 修改密码弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      title="修改密码"
      :visible.sync="dialogPass"
      width="550px"
      @closed="resetForm('updateForm')"
    >
      <el-form
        :model="updateForm"
        ref="updateForm"
        :rules="updateFormRules"
        size="mini"
      >
        <el-form-item
          label="密码"
          prop="oldpwd"
          :label-width="formLabelWidth"
        >
          <el-input
            class="width-300"
            type="password"
            maxlength="32"
            v-model="updateForm.oldpwd"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="新密码"
          prop="newpwd"
          :label-width="formLabelWidth"
        >
          <el-input
            class="width-300"
            type="password"
            maxlength="32"
            v-model="updateForm.newpwd"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="确认新密码"
          prop="checkPass"
          :label-width="formLabelWidth"
        >
          <el-input
            class="width-300"
            type="password"
            maxlength="32"
            v-model="updateForm.checkPass"
            placeholder="请确认新密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="handleResetSubmit('updateForm')"
          size="small"
          >提 交</el-button
        >
        <el-button @click="resetForm('updateForm')" size="small">重 置</el-button>
      </div>
    </el-dialog>

    <div class="header">
<!--      <div class="title"><img src="../assets/logo1.png" style="width: 260px;margin-top: 2px;"/></div>-->
      <div class="title">工业物联网管理系统</div>
      <div class="info">
        <span>欢迎您: {{ userInfo.username || "" }}</span>
        |
        <span>当前用户: {{ userInfo.realname || "" }}</span>
        |
        <span>最近登录时间: {{ userInfo.lastTime || "" }}</span>
        |
        <el-link class="logout" :underline="false" @click="logout">安全退出</el-link>
      </div>
    </div>

    <div class="content">
      <el-menu
        style="overflow: auto"
        :router="true"
        :collapse="isCollapse"
        v-for="(item, index) in subMenu"
        :key="index"
        :default-active="subMenuActive"
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :active-text-color="variables.menuActiveText"
        :unique-opened="true"
      >
        <el-menu-item
          v-if="false"
          :index="idxMenu.menuId"
          :key="idxMenu.menuId"
          @click="clickMenu(idxMenu)"
          >
          <i :class="idxMenu.menuPic"></i>
          <span class="menuName">{{idxMenu.menuName}}</span>
        </el-menu-item>
        <el-submenu
          v-if="item.hide!='1'"
          :index="item.menuId"
          v-for="(item, index) in subMenu[index].childMenu"
          :key="index"
        >
          <template slot="title">
            <i :class="item.menuPic+' menuIcon'"></i>
            <span class="menuName">{{ item.menuName }}</span>
          </template>
          <el-menu-item
            v-if="item.hide!='1'"
            :index="item.menuId"
            v-for="(item, index) in item.childMenu"
            :key="index"
            @click="clickMenu(item)"
          >
            <i :class="item.menuPic+' menuIcon'"></i>
            <span class="menuName">{{ item.menuName }}</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>

      <ul
        v-show="visible"
        :style="{ left: left + 'px', top: top + 'px' }"
        class="contextmenu"
      >
        <!-- <li @click="refreshSelectedTag(selectedTag)">刷新</li> -->
        <li
          v-if="!(selectedTag.meta && selectedTag.meta.affix)"
          @click="removeTab(selectedTag)"
        >
          关闭选中标签
        </li>
        <li @click="closeOthersTags(selectedTag)">关闭其它标签</li>
        <li @click="closeAllTags(selectedTag)">关闭所有标签</li>
      </ul>

      <el-row class="nav" style="margin-left: 1px">
        <el-col class="tab-card">
          <el-button
            plain
            size="medium"
            :icon="isCollapse?'el-icon-s-unfold':'el-icon-s-fold'"
            class="tab-btn absolute"
            style="z-index: 2"
            @click="toggleMenu"
          ></el-button>
          <el-tabs
            @contextmenu.prevent.native="openMenu($event)"
            stretch
            type="card"
            v-model="activeName"
            @tab-remove="removeTab"
            @tab-click="handleClickTab($event.name)"
            class="absolute tabBar"
            style="padding-bottom: 1px; max-width: 100%"
          >
            <el-tab-pane
              v-for="item in tabMenu"
              :key="item.menuId"
              :label="item.menuName"
              :name="item.menuId"
              :closable="item.menuId.indexOf('IdxManager')===-1"
              @contextmenu="openMenu($event)"
            ></el-tab-pane>
          </el-tabs>
        </el-col>

        <el-col>
          <el-row>
            <transition name="slide-fade">
              <keep-alive :include="cachedViews">
                <router-view></router-view>
              </keep-alive>
            </transition>
          </el-row>
        </el-col>

        <el-col v-if="$route.path != '/home'">
          <div class="center h11 userDetailTitle pb0-5">
            Copyright © 2024 All rights reserved 版权所有 广州赛程电子科技有限公司
            <a
              href="http://beian.miit.gov.cn"
              target="_blank"
              style="text-decoration: none"
              class="userDetailTitle"
              >粤ICP备2024332972号</a
            >
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import variables from '@/assets/variables.scss'
import { resetRouter } from '@/router'
import rsa from '@/utils/rsa'

export default {
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.updateForm.newpwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    var checkPassWord = (rule, value, callback) => {
      // console.log(value)
      if (!value) {
        return callback(new Error('密码不能为空'))
      } else {
        const reg = /^.*(?=.{6,16})(?=.*\d)(?=.*[A-Z]{1,})(?=.*[a-z]{1,}).*$/
        // console.log(reg.test(value));
        if (reg.test(value)) {
          callback()
        } else {
          return callback(
            new Error('6位-16位，必须包含大写字母、小写字母、数字')
          )
        }
      }
    }
    return {
      publicPath: process.env.BASE_URL,
      activeIndex: '$route.path',
      subMenuActive: '$route.path',
      activeName: 'second',
      dialogPersonal: false,
      dialogPlat: false,
      dialogPass: false,
      formLabelWidth: '120px',
      visible: false,
      top: 15,
      left: 15,
      variables,
      selectedTag: '',
      cachedViews: ['redirect'],
      updateForm: {
        oldpwd: '',
        newpwd: '',
        checkPass: ''
      },
      updateFormRules: {
        oldpwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        newpwd: [
          { required: true, validator: checkPassWord, trigger: 'blur' }
        ],
        checkPass: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ]
      },
      platformNo: [],
      status: [],
      userType: [],
      tabMenu: [],
      menuData: [],
      screenWidth: window.innerWidth,
      subMenu: [],
      idxMenu: {},
      urlPdf: '',
      isCollapse: false,
      iconColor: [
        '#ffac13',
        '#e53935',
        '#83c44e',
        '#ee3768',
        '#83ad74',
        '#16a085',
        '#00c0a5',
        '#7476ad',
        '#9871ad',
        '#2196f3'
      ]
    }
  },
  // beforeCreate() {
  //   if(sessionStorage.getItem('isLoad')) {
  //       location.reload();
  //       sessionStorage.removeItem('isLoad')
  //   }
  // },
  mounted () {
    // console.log(this.$route, variables, variables.menuBg)
    this.init()
    this.winResize()
    // this.getUserInfo()

    setInterval(() => {
      let menus = document.getElementsByClassName('menuIcon')
      for (let i = 0; i < menus.length; i++) {
        let menu = menus[i]
        let ranColorIndex = Math.floor(Math.random() * this.iconColor.length)
        menu.style.color = this.iconColor[ranColorIndex]
      }
    }, 2000)
  },
  watch: {
    tabMenu (val) {
      // console.log(val, 'val')
      sessionStorage.setItem('tabMenu', JSON.stringify(val))
      // console.log(JSON.parse(sessionStorage.getItem('tabMenu')), 'session')
      if (val.length == '0') {
        this.$router.push({ name: 'home' })
        if (this.idxMenu) {
          this.clickMenu(this.idxMenu)
          this.$router.push({ name: this.idxMenu.menuId })
        }
        // console.log(this.userInfo)
        this.cachedViews = []
      } else {
        this.cachedViews = []
        val.forEach((item) => {
          this.cachedViews.push(item.menuId)
        })
      }
      // console.log(this.cachedViews)
    },
    screenWidth (val) {
      // console.log(val)
      if (val < 850) {
        this.isCollapse = true
      }
    },
    subMenuActive (val) {
      // console.log(val)
    },
    visible (value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    },
    $route (to, from) {
      // console.log('======================',  to , from )
      // console.log('-------------------------------+', this.menuData)
      let menu = this.getMenu(this.menuData, to.name)
      // console.log('-------------------------------=', menu)
      if (menu) {
        this.clickMenu(menu)
      }
      // if (to.name == 'customerUserManager') {
      //   this.clickMenu({
      //     menuId: 'customerUserManager',
      //     menuName: '客户账号管理',
      //     pageUrl: '',
      //     menuPic: 'icon-wenzhang1',
      //     menuLevel: 3,
      //     seq: 2,
      //     childMenu: [],
      //     funcList: []
      //   })
      // }
      // if (to.name == 'mobileList') {
      //   this.clickMenu({
      //     menuId: 'mobileList',
      //     menuName: '订单号码列表',
      //     pageUrl: '',
      //     menuPic: 'icon-wenzhang1',
      //     menuLevel: 3,
      //     seq: 2,
      //     childMenu: [],
      //     funcList: []
      //   })
      // }
    }
  },
  methods: {
    init () {
      // console.log('head init')
      // 取menuData数据
      this.menuData = JSON.parse(sessionStorage.getItem('menuData')) || []
      // 获取侧标栏数据
      this.getSubMenu(this.$route.path.substr(1))
      // 激活menu和tab
      this.activeIndex = this.$route.path.substr(1)
      this.subMenuActive = this.$route.path.substr(1)
      this.activeName = this.$route.path.substr(1)

      // 取tabmenu的缓存
      this.tabMenu = JSON.parse(sessionStorage.getItem('tabMenu')) || []
    },
    getMenu (menuArr, menuId) {
      for (let i = 0; i < menuArr.length; i++) {
        let menu = menuArr[i]
        if (menu.menuId == menuId) {
          return menu
        }
        if (menu.childMenu && menu.childMenu.length > 0) {
          let that = this.getMenu(menu.childMenu, menuId)
          if (that) {
            return that
          }
        }
      }
      return null
    },
    openMenu (e) {
      // console.log(e)
      // console.log(e.target.innerText)
      // console.log(this.tabMenu)
      const menuName = e.target.innerText || e.target.parentNode.innerText
      if (menuName) {
        const { menuId } = this.tabMenu.find(
          (item) => item.menuName == menuName
        )
        this.selectedTag = menuId
        // console.log(this.selectedTag)
      }

      this.left = e.clientX

      this.visible = true
    },
    closeMenu () {
      this.visible = false
    },
    refreshSelectedTag (view) {
      // const { fullPath } = view
      // console.log(view)
      this.$nextTick(() => {
        this.$router.replace({
          path: '/redirect' + '/' + view
        })
      })
      this.activeName = this.selectedTag
    },
    closeOthersTags (view) {
      this.tabMenu = this.tabMenu.filter((item) => item.menuId == view)
      this.activeName = this.selectedTag
    },
    closeAllTags (view) {
      this.tabMenu = []
      this.$router.push('/home')
    },
    // 监听视口变化
    winResize () {
      // 如果视口宽度小于850就收起侧边栏
      this.isCollapse = this.screenWidth < 850
      window.onresize = () => {
        // 定义窗口大小变更通知事件
        this.screenWidth = document.documentElement.clientWidth // 窗口宽度
      }
    },
    // 个人信息
    handlePersonal () {
      // console.log('handlePersonal')
      this.dialogPersonal = true
    },
    // 平台信息
    handlePlat () {
      this.dialogPlat = true
    },
    // 修改密码
    changePassword () {
      axios({
        url: this.baseUrl + '/modifyPwd',
        method: 'POST',
        data: {
          oldpwd: rsa.rsaPublicData(this.updateForm.oldpwd),
          newpwd: rsa.rsaPublicData(this.updateForm.newpwd)
        }
      })
        .then((res) => {
          if (res.data.code === '0000') {
            this.dialogPass = false
            this.$message.success('密码修改成功')
            // console.log('success', 'changePassword')
          }
        })
        .catch((err) => {
          console.log(err, 'changePassword')
        })
    },
    // 退出
    logout () {
      // console.log('logout')
      sessionStorage.clear()
      resetRouter()
      // console.log(this.$router, 'resetRoute, logout')
      this.$router.push('/login')
    },
    // 点击切换侧边栏大小
    toggleMenu () {
      this.isCollapse = !this.isCollapse
    },
    // 获取侧边栏数据
    getSubMenu (key) {
      // 根据menuData当前menu的值取对应的submenu
      this.subMenu = this.menuData.filter((item, index) => {
        if (item.menuId === key) {
          return true
        } else {
          return false
        }
      })
      // 如果submenu为空，取缓存中的值，刷新页面的时候取
      if (this.subMenu.length === 0) {
        this.subMenu = JSON.parse(sessionStorage.getItem('subMenu'))
        let idxMenuStr = sessionStorage.getItem('idxMenu')
        this.idxMenu = null
        if (idxMenuStr && idxMenuStr != 'undefined') {
          this.idxMenu = JSON.parse(idxMenuStr)
        }
        if (this.subMenu && !this.idxMenu) {
          let idxMenus = this.subMenu[0].childMenu.filter((item, index) => item.menuId.indexOf('IdxManager') > -1)
          if (idxMenus) {
            this.idxMenu = idxMenus[0]
            this.subMenu[0].childMenu = this.subMenu[0].childMenu.filter((item, index) => item.menuId.indexOf('IdxManager') === -1)
            if (this.idxMenu) {
              sessionStorage.setItem('idxMenu', JSON.stringify(this.idxMenu))
            }
          } else {
            this.idxMenu = {}
          }
        }
      }

      // console.log(this.menuData, 'menuData')
      // console.log(this.subMenu, this.subMenu[0].menuName, 'submenu')
      sessionStorage.setItem('subMenu', JSON.stringify(this.subMenu))
    },
    clickMenu (componentName) {
      // console.log('fdafadf', componentName)
      // this.tabMenu = JSON.parse(sessionStorage.getItem('tabMenu'))
      // 让tabview的高亮和menu的高亮一致
      this.activeName = componentName.menuId
      // console.log(componentName)
      // this.tabMenu.push(componentName.menuId)

      // 查找tabmenu中有无此路由，没有就添加，有就激活tag
      let result = this.tabMenu.some((item) => {
        if (item.menuId === componentName.menuId) {
          return true
        }
      })
      // console.log('result', result)

      if (!result) {
        this.tabMenu.push(componentName)
      } else {
        this.activeName = componentName.menuId
      }
      // console.log(this.tabMenu, componentName.menuId)
      sessionStorage.setItem('menuId', componentName.menuId)
      // console.log(componentName.menuId, 'dddfff')
      // console.log(this.tabMenu.indexOf(componentName.menuId))
      // sessionStorage.setItem('tabMenu', JSON.stringify(this.tabMenu))
    },
    handleClickTab (route) {
      // console.log(route)
      this.$router.push(route)
      // 点击tab的时候让submenu激活
      this.subMenuActive = route
    },
    // 删除tag
    removeTab (targetName) {
      // console.log(targetName)
      // console.log(this.tabMenu.indexOf(targetName))
      // 根据targetName找出和tabmenu中id相同的这个数组
      let newArr = this.tabMenu.filter((item) => {
        if (item.menuId === targetName) {
          return true
        }
      })
      // console.log(newArr)
      // 找出这个数组的索引值
      var index = this.tabMenu.findIndex(function (x) {
        return x.menuId == newArr[0].menuId
      })
      // console.log(index)
      // 删除这一项
      this.tabMenu.splice(index, 1)
      // console.log(this.tabMenu, 'efefef')
      if (this.tabMenu && this.tabMenu.length != 0) {
        index = index == 0 ? 1 : index
        this.$router.push('/' + this.tabMenu[index - 1].menuId)
        this.activeName = this.tabMenu[index - 1].menuId
        this.subMenuActive = this.tabMenu[index - 1].menuId
      }
    },
    // 点击nav时取侧边栏的数据
    handleSelect (key, keyPath) {
      this.getSubMenu(key)
      // console.log(key, keyPath)
      // console.log(this.$route.name)
    },
    handleOpen (key, keyPath) {
      // console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      // console.log(key, keyPath)
    },
    handleResetSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.changePassword()
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    },
    // 清空表单
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang="scss">
.app-wrapper {
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
  .el-tabs--card > .el-tabs__header {
    padding: 0 10px 0 60px;
  }
  .tabBar > div {
    padding: 0 10px 0 60px;
  }
  .nav .tab-card .el-tabs__header {
    padding: 0 10px 0 60px;
  }
  .el-tabs--card > .el-tabs__header .el-tabs__nav {
    display: block !important;
  }
  .el-tabs__nav.is-stretch {
    min-width: 0;
  }

  .paramDetail {
    min-height: 43px;
    padding: 10px;
    line-height: 1.5;
  }
  .plat-info {
    .paramDetail {
      min-height: 33px;
      padding: 5px;
    }
    .el-dialog__body {
      padding: 5px 20px;
    }
  }
  .user-avatar {
    width: 30px;
    height: 30px;
    border-radius: 30px;
    margin-top: 15px;
  }
  .user-drop {
    height: 40px;
    line-height: 40px;
    float: right;
    margin-right: 2rem;
  }
  .user-drop i {
    margin-left: 5px;
    position: absolute;
    top: 50%;
    margin-top: -5px;
    color: #949494;
  }
  .el-dropdown-menu__item {
    padding: 0;
  }
  .slide-fade {
    position: absolute;
    left: 0;
    right: 0;
  }
  .slide-fade-enter-active {
    transition: all 0.5s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.5s cubic-bezier(2, 0.5, 0.8, 1);
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    left: 0;
    right: 0;
    transform: translatex(-40px) translateY(-20px);
    opacity: 0;
  }

  .content .el-menu {
    border-right: none;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    min-width: 224px;
    min-height: 400px;
  }

  .content {
    display: flex;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 45px;
    background-color: #f2f2f2;
  }
  .el-menu {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .nav {
    width: 100%;
    border-style: solid;
    border-radius: 2px;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
    /* height: 40px; */
    background: #f2f2f2;
    overflow: auto;
  }
  .nav .tab-card {
    /* border-width: 1px; */
    border-style: solid;
    border-radius: 2px;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
    height: 40px;
    background-color: #fff;
    // min-width: 1100px;
    width: 100%;

    // display: flex;
  }
  .tab-btn {
    border: none;
    border-radius: 0;
    font-size: 20px;
    /* border-right: 1px solid rgb(211, 211, 211); */
  }
  .tab-btn:hover {
    border: none;
    border-radius: 0;
    border-right: 1px solid rgb(211, 211, 211);
  }
  .header {
    height: 45px;
    background-color: #00A9FC;
  }
  .header .title {
    color: #ffffff;
    float: left;
    height: 45px;
    line-height: 45px;
    margin-left: 1rem;
    font-size: 16px;
    font-weight: bold;
  }
  .header .info {
    color: #ffffff;
    float: right;
    height: 45px;
    line-height: 45px;
    margin-right: 1rem;
    font-size: 16px;
  }
  .header .logout {
    color: #ffffff;
    font-size: 16px;
  }
}
</style>
